"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function mapObjectValues(object, fn) {
    const mappedObject = {};
    Object.entries(object).forEach(([key, value]) => {
        mappedObject[key] = fn(value);
    });
    return mappedObject;
}
exports.default = mapObjectValues;
